export default __webpack_public_path__ + "static/layout-example-dark-1bea651f6eac6ac49809f09996adf00e53f4e244fdd857659423afed52c311db.png";